export default "__VITE_ASSET__f8ede5bb__"